import { computed } from 'mobx';

export default class UnitModel {
  id;
  store;

  constructor(store, unit) {
    this.store = store;
    this.id = +unit.id;
    this.name = unit.name;
    this.symbol = unit.symbol;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      symbol: this.symbol,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.symbol = json.symbol;
  }
}



// WEBPACK FOOTER //
// ./src/models/UnitModel.js